import React, { useEffect, useState } from 'react'
import { useAtom } from 'jotai'
import useFetchEntitiesWithCache from '../../hooks/useFetchEntitiesWithCache'
import { useFilterIssues } from '../issues/utils'
import { issueFiltersAtom, IssueFilterType } from '../../atoms/issueAtom'
import { ScatterPlot } from './ScatterPlot'
import { useLogUserEvent } from '../../hooks/useLogUserEvent'
import UserEventApi from '../../api/UserEventApi'

const DISABLED_ISSUE_TYPE_FILTER = ['IPO', 'Non-cash issue'] as const
type DisabledItems = (typeof DISABLED_ISSUE_TYPE_FILTER)[number]

export const ScatterPlotView = () => {
    useLogUserEvent(UserEventApi.EVENT_TYPES.SHOW_STATS_SCATTER_PLOT)
    const { isLoading, result: fetchedIssues } = useFetchEntitiesWithCache('issue')
    const [filters, setFilters] = useAtom(issueFiltersAtom)
    const filteredIssues = useFilterIssues(fetchedIssues || [], filters)
    const [oldFilter, setOldFilter] = useState<IssueFilterType | null>(null)
    const selectedIssueType = filters.issueTypes.value[0] as Exclude<
        IssueFilterType['issueTypes']['value'][number],
        DisabledItems
    >

    useEffect(() => {
        setFilters((prevFilters) => {
            if (!oldFilter) setOldFilter(prevFilters)

            return {
                ...prevFilters,
                issueTypes: {
                    value: ['Rights issue'],
                    disabledItems: [...DISABLED_ISSUE_TYPE_FILTER],
                    isSingleChoice: true,
                },
            }
        })

        return () => {
            if (oldFilter) setFilters((filters) => ({ ...filters, issueTypes: { ...oldFilter.issueTypes } }))
        }
    }, [setFilters, setOldFilter, oldFilter])

    return <ScatterPlot isLoading={isLoading} issueType={selectedIssueType} issues={filteredIssues} />
}
